import React from 'react';
import { Breadcrumb, Input, Button, Icon, Select, Affix, Spin, message } from 'antd';
import { Container, Row, Col } from 'reactstrap';
import SERVER_URL from '../Global';
import HandleRegistration from './HandleRegistration';
import { UserCardDetail } from './UserCardDetail';

const { Option } = Select;

export class HandleUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: this.props.token,
            users: [],
            loading: true,
            top: 10,
            orderBy: 'surname',
            order: 1,
            searchName: '',
            detailUser: [],
            loadingDetail: true,
            editedName: '',
            editedSurname: '',
            portraitImage: '',
            contacts: [],
            companyId: '',
            iniziale: 'A',
            alfabeto: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '#'],
            detailUserBridge: [],
            isItABridge: false,
            loadingComp: true,
            company: [],
            loadingXML: false,
            inDesignXML: '',
            roleName: '',
            hasFiltersOn: false,
            pageNumber: 1,
            loadingBelow: false,
            categories: [],
            categoryName: '',
            catId: '',
            showList: true,
        };
        this.handleNameChange = this.handleNameChange.bind(this);
        this.editName = this.editName.bind(this);
        this.editSurname = this.editSurname.bind(this);
        this.getDetailBridge = this.getDetailBridge.bind(this);
        this.exportInDesign = this.exportInDesign.bind(this);
        this.hrReload = this.hrReload.bind(this);
        this.handleFilters = this.handleFilters.bind(this);
        this.handleRoleName = this.handleRoleName.bind(this);
        this.infiniteScroll = this.infiniteScroll.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.handleCat = this.handleCat.bind(this);
        this.deleteGeo = this.deleteGeo.bind(this);
        this.registrationSwitch = this.registrationSwitch.bind(this);
        this.callbackShowList = this.callbackShowList.bind(this);
        this.goBack = this.goBack.bind(this);        
        this.recallDisabled = this.recallDisabled.bind(this);

        document.title = "Polar - Users"

        fetch(
            `${SERVER_URL + 'api/users/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "usernameLike": this.state.searchName,
                    "page": 1,
                    "pageSize": 60,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": this.state.orderBy,
                        "order": this.state.order
                    },
                    "Status": 1
                })
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ users: res.data, loading: false, maxPageSize: res.params.totalPages });

                    if (this.state.order === undefined) {
                        this.setState({ order: '1' });
                    }

                    if (this.state.orderBy === undefined) {
                        this.setState({ orderBy: ' ' });
                    }

                    if (this.state.searchName === undefined) {
                        this.setState({ searchName: ' ' });
                    }
                } else {
                    this.setState({ users: [], loading: false });
                }
            })
    };

    handleCat(value) {
        if (value > 0) {
            let catName = this.state.categories.find(x => x.catId == value).name;

            this.setState({ catId: value, categoryName: catName })
        } else {
            this.setState({ catId: '', categoryName: '' })
        }
    }

    recallDisabled() {
        fetch(
            `${SERVER_URL + 'api/users/list?lang=en'}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${this.state.user}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "usernameLike": this.state.searchName,
                "page": 1,
                "totalPages": 0,
                "totalItems": 0,
                "pageSize": 40,
                "pageSizeOptions": null,
                "ordering": {
                    "orderPropertyName": this.state.orderBy,
                    "order": this.state.order
                },
                "firstItemNumber": 0,
                "lastItemNumber": 0,
                "entityId": 0
            })
        }
        ).then(response => response.json())
            .then(res => {
                if (res.data != null) {
                    this.setState({ users: res.data, loading: false, loadingComp: true, maxPageSize: res.params.totalPages });
                }
                else {
                    this.setState({ loading: false, users: [], loadingComp: true });
                }
            })
    }

    exportInDesign() {
        this.setState({ loadingXML: true });

        fetch(
            `${SERVER_URL + 'api/export/hrIndex?lang=en'}`, {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                }
            }
        ).then(response => response.text())
            .then(response => {
                this.setState({ inDesignXML: response, loadingXML: false });
            })
    }

    hrReload(orderBy, order) {
        this.setState({ loading: true });
        fetch(
            `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "NameSurname": this.state.searchName,
                    "page": 1,
                    "pageSize": 60,
                    "pageSizeOptions": null,
                    "brCompanyCategoryId": this.state.catId,
                    "ordering": {
                        "orderPropertyName": orderBy,
                        "order": order
                    },
                    "Status": 1,
                    "role": this.state.roleName
                })
            }
        ).then(response => response.json())
            .then(res => {
                this.setState({ users: res.data, loading: false, order: order, orderBy: orderBy, maxPageSize: res.params.totalPages });
            })
    }

    clearFilters() {
        this.setState({ roleName: '', categoryName: '', catId: '' }, this.handleFilters)
    }

    infiniteScroll(e) {
        let users = this.state.users
        const fondo = e.target.scrollHeight - e.target.scrollTop < e.target.clientHeight + 3;
        if (fondo && this.state.maxPageSize > this.state.pageNumber) {
            let newPage = this.state.pageNumber + 1
            this.setState({ loadingBelow: true });
            fetch(
                `${SERVER_URL + 'api/hr/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "usernameLike": this.state.searchName,
                        "page": newPage,
                        "pageSize": 60,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                        "Status": 1,
                        "role": this.state.roleName
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ users: users.concat(res.data), pageNumber: newPage, loadingBelow: false });
                })
        }
    }

    handleRoleName(event) {
        this.setState({ roleName: event.target.value });
    }

    handleFilters() {
        if (this.state.roleName !== '' || this.state.categoryName !== '') {
            this.setState({ hasFiltersOn: true }, () => { this.hrReload(this.state.orderBy, this.state.order) })
        }
        else {
            this.setState({ hasFiltersOn: false }, () => { this.hrReload(this.state.orderBy, this.state.order) })
        }
    }
    DeleteJson(hrId) {
        fetch(`${SERVER_URL + 'api/hr/' + hrId + '/true'}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`
            },
        });
    }

    getDetail(userId) {
        const index = this.state.users.findIndex(user => user.userId == userId);

        this.setState({ detailUser: this.state.users[index], loadingDetail: false, isItABridge: true, loadingComp: true });
    }

    getDetailBridge(hrId) {
        fetch(`${SERVER_URL + 'api/hr/' + hrId}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.state.user}`
            },
        }).then(response => response.json())
            .then(res => {
                this.setState({ detailUserBridge: res.data, loadingDetail: false, isItABridge: true });
            });
    }

    getFiles(files) {
        this.setState({ portraitImage: files.base64 })
    }

    handleNameChange(event) {
        this.setState({ searchName: event.target.value })
        if (event.target.value.length > 2 || event.target.value.length == 0) {
            this.setState({ loading: true });
            fetch(
                `${SERVER_URL + 'api/users/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "usernameLike": event.target.value,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ users: res.data, loading: false, maxPageSize: res.params.totalPages });
                    }
                    else {
                        this.setState({ loading: false, users: [], maxPageSize: 0 });
                    }
                })
        }
    }

    editName(event) {
        this.setState({ editedName: event.target.value });
    }

    editSurname(event) {
        this.setState({ editedSurname: event.target.value });
    }

    closeDetail() {
        this.setState({ loadingDetail: true });
    }

    deleteGeo() {
        fetch(
            `${SERVER_URL + 'api/users/' + this.state.detailUser.userId}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                }
            }
        ).then(response => response.json())
            .then(res => {
                if (res.data == "disabled") {
                    message.warning("The user could not be deleted and therefore was disabled");
                }
            fetch(
                `${SERVER_URL + 'api/users/list?lang=en'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "usernameLike": this.state.searchName,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": this.state.orderBy,
                            "order": this.state.order
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ users: res.data, loading: false, loadingComp: true, maxPageSize: res.params.totalPages, loadingDetail: true });
                    }
                    else {
                        this.setState({ loading: false, users: [], loadingComp: true, loadingDetail: true });
                    }
                })
        })
    }

    registrationSwitch() {
        this.setState({ showList: false })
    }

    callbackShowList = (childData) => {
        this.setState({ showList: childData })
    }

    goBack() {
        this.setState({ showList: true })
    }
    
    render() {

        let contentsDetail = !this.state.loadingDetail ? <UserCardDetail delete={this.deleteGeo} recallDisabled={this.recallDisabled} token={this.state.user} user={this.state.detailUser} /> : "";

        let tableContent = this.state.loading ?
            <tr className="spinContainer">
                <td>
                    <Icon type="loading" style={{ fontSize: 114, color: '#1890ff' }} spin />
                </td>
            </tr> :
            this.state.users.map(user => {
                let enabled = user.isEnabled ? "Enabled" : "Disabled"
                let ruolo = user.userRole != null ? user.userRole.name : null
                return (
                    <tr key={user.userId}>
                        <td onClick={() => this.getDetail(user.userId)}>{user.username}</td>
                        <td onClick={() => this.getDetail(user.userId)}>{user.lastName}</td>
                        <td onClick={() => this.getDetail(user.userId)}>{user.firstName}</td>
                        <td onClick={() => this.getDetail(user.userId)}>{user.email}</td>
                        <td onClick={() => this.getDetail(user.userId)}>{ruolo}</td>    
                        <td onClick={() => this.getDetail(user.userId)}>{enabled}</td>
                    </tr>
                )
            })

        let infiniteScroll = this.state.loadingBelow ? <Spin className="preloaderBelow" indicator={<Icon type="loading" style={{ fontSize: 114 }} spin />} /> : ''

        let noHr = this.state.users.length == 0 ?
            <div className="noHr">
                <h3>No users found</h3>
            </div> : ''

        let listOrNew = this.state.showList ?
            <Row style={{ width: '100%' }}>
                <Col sm="9" onScroll={this.infiniteScroll} className="mainBoard">
                    <div className="tableContainer">
                        <table className='table table-striped'>
                            <thead>
                                <tr>
                                    <th style={{ width: '18%' }}>Username</th>
                                    <th style={{ width: '18%' }}>Surname </th>
                                    <th style={{ width: '18%' }}>Name</th>
                                    <th style={{ width: '18%' }}>Email</th>
                                    <th style={{ width: '18%' }}>Role</th>
                                    <th style={{ width: '10%' }}>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableContent}
                            </tbody>
                        </table>
                        {infiniteScroll}
                    </div>
                    {noHr}

                </Col>
                <Col sm="3">
                    <Affix offsetTop={this.state.top}>
                        <div className="inner">
                            {contentsDetail}
                        </div>
                    </Affix>
                </Col> 
            </Row>
            : <HandleRegistration token={this.state.user} parentShowList={this.callbackShowList}   />

        let breadCrumbContent = this.state.showList ?
            <Col sm="12" style={{ display: 'inline-flex', height: '0' }}>
                <Breadcrumb className="bread">
                    <Breadcrumb.Item>Users</Breadcrumb.Item>
                </Breadcrumb>
                <div className="plusButtonCat">
                    <Button style={{ marginRight: '10px' }} className="button create" onClick={this.registrationSwitch}><Icon type="plus" /></Button>
                </div>
                <div className="ant-breadcrumb searchList cat midSearchBar">
                    <Input autoComplete="new-password" placeholder="Search Username" style={{ width: '100%', marginTop: '-1em' }} allowClear={true} value={this.state.searchName} onChange={this.handleNameChange} />
                    <Icon className="homeViewSearch" onClick={this.handleFilters} type="search" />
                </div>

            </Col>
            : 
            <Col sm="12" style={{ display: 'inline-flex', height: '0' }}>
                <Button className="backButt" icon="caret-left" onClick={this.goBack}></Button>
                <Breadcrumb className="bread">                    
                    <Breadcrumb.Item>Create Users</Breadcrumb.Item>
                </Breadcrumb>
            </Col>

        return (
            <Container fluid={true} className="userList">
                <Row>
                    {breadCrumbContent}

                    {listOrNew}
                </Row>
            </Container>
        )
    }


}



// WEBPACK FOOTER //
// ./src/Users/HandleUsers.js